<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/workshop"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="车间编码">
            <el-input v-model.trim="filter.workshopCode" placeholder="请输入车间编码" clearable />
          </el-form-item>
          <el-form-item label="车间全称">
            <el-input v-model.trim="filter.workshopName" placeholder="请输入车间全称" clearable />
          </el-form-item>
          <el-form-item label="车间简称">
            <el-input v-model.trim="filter.workshopShortName" placeholder="请输入车间简称" clearable />
          </el-form-item>
          <el-form-item label="所属工厂">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable />
          </el-form-item>
          <el-form-item label="车间类型">
            <el-select v-model="filter.workshopType" placeholder="请选择车间类型" clearable>
              <el-option v-for="item in workshopTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="车间状态">
            <el-select v-model="filter.workshopStatus" placeholder="请选择车间状态" clearable>
              <el-option v-for="item in workshopStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkShopEdit ref="workShopEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkShopEdit from "./WorkShopEdit";

export default {
  components: { viewTable, WorkShopEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(149),
        editAuth: this.$auth(150),
        delAuth: this.$auth(151),
      },
      workshopTypeOptions: [
        { label: "生产", value: 1 },
        { label: "仓储", value: 2 },
        { label: "质检", value: 3 },
        { label: "辅助", value: 4 },
        { label: "试制", value: 5 },
      ],
      workshopStatusOptions: [
        { label: "筹建", value: 0 },
        { label: "正常", value: 1 },
        { label: "临时停产", value: 2 },
        { label: "永久停用", value: 3 },
      ],
      filter: {
        workshopCode: "",
        workshopName: "",
        workshopShortName: "",
        factoryName: "",
        workshopType: null,
        workshopStatus: null,
      },
      columnsProperty: [
        { tooltip: true, key: "workshopCode", width: 130, align: "center" },
        { tooltip: true, key: "workshopName", minWidth: 180 },
        { tooltip: true, key: "workshopShortName", width: 120 },
        { tooltip: true, key: "factoryName", minWidth: 150 },
        { tooltip: true, key: "workshopTypeName", width: 100, align: "center" },
        { tooltip: true, key: "workshopStatusName", width: 100, align: "center" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.workShopEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/workshop", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
